module.exports = __webpack_public_path__ + "media/images/lb/457-df72736bde8f74d7b20df671f477dfe4.svg";